export function getListPickerConfigurationOption(type, key) {

  const options = {
    // This configuration is specific to Apple message (bzc).
    'html.ListPickerBox': {
      'enable-box-header': false,
      'box-header-max-length': null, // Not applicable
      'box-footer-max-length': 1000,
      'display-remaining-char-for-box-footer': false,
      'enable-image-in-answer': true,
      'enable-open-sections-button': false,
      'open-sections-button-label-max-length': null, // Not applicable
      'section-title-max-length': 1000,
      'display-remaining-char-for-section-title': false,
      'answer-title-max-length': 1000,
      'display-remaining-char-for-answer-title': false,
      'answer-subtitle-max-length': 1000,
      'display-remaining-char-for-answer-subtitle': false,
      'mandatory-section': true,
      'min-section': 1,
      'max-section': 1,
      'min-answer': 1,
    },
    'html.WhatsappListMessageBox': {
      'enable-box-header': true,
      'box-header-max-length': 60,
      'box-footer-max-length': 60,
      'display-remaining-char-for-box-footer': true,
      'enable-image-in-answer': false,
      // https://developers.facebook.com/docs/whatsapp/on-premises/reference/messages#interactive-object
      'body-max-length': 1024,
      // https://developers.facebook.com/docs/whatsapp/on-premises/reference/messages#section-object
      'enable-open-sections-button': true,
      'open-sections-button-label-max-length': 20,
      'display-remaining-char-for-section-title': true,
      'section-title-max-length': 24,
      'mandatory-section': true,
      'answer-title-max-length': 24,
      'answer-subtitle-max-length': 72,
      'display-remaining-char-for-answer-title': true,
      'display-remaining-char-for-answer-subtitle': true,
      'min-section': 1,
      'max-section': 10,
      'min-answer': 1,
    }
  }
  return options[type][key];
}
